import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'normalizeDate',
    standalone: true
})
export class NormalizeDatePipe implements PipeTransform {
    transform(value: any): any {
        if (value === null || value === undefined || value === '') {
            return null;
        }
        if (value instanceof Date && !isNaN(value.getTime())) {
            return value.toISOString();
        }

        if (/^\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2}$/.test(value)) {
            return value.replace(" ", "T");
        }

        if (/^\d{4}\/\d{2}\/\d{2}$/.test(value)) {
            return value.replace(/\//g, "-") + "T00:00:00";
        }

        const parsed = new Date(value);
        if (!isNaN(parsed.getTime())) {
            return parsed.toISOString();
        }

        return null;
    }
}
